export const novemberAbbreviatedLowercase = "OdCFKb";
export default {novemberAbbreviatedLowercase};